module.exports = __webpack_public_path__ + "img/IMG_7233.81c53483.webp";